import { Group, List, Skeleton, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from 'react-responsive';

type EntrantsSkeletonsProps = {
  count: number;
};

function EntrantsSkeletons({ count }: EntrantsSkeletonsProps) {
  const theme = useMantineTheme();
  const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.lg });

  return (
    <List spacing="md" listStyleType="none" size={isTablet ? 'sm' : 'md'}>
      {Array(count)
        .fill(0)
        .map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <List.Item key={index} display="flex">
            <Group align="center" spacing="sm">
              {/* Numbers taken from real values in EntriesList */}
              <Skeleton height={isTablet ? 26 : 38} circle />
              <Skeleton height={isTablet ? 17 : 20} width={80 + Math.round(Math.random() * 50)} />
            </Group>
          </List.Item>
        ))}
    </List>
  );
}

export default EntrantsSkeletons;
